import jwt_decode from "jwt-decode";
import moment from "moment";
import 'moment/locale/tr';
import {OptionType} from "../../containers/QuestionPage/Option/Option";
import {State} from "../models/custom/state";
import {JwtDto} from "../models/dtos/jwt.dto";
import {MeDto} from "../models/dtos/me.dto";
import {RewardDto} from "../models/dtos/reward.dto";
import {RewardDescription} from "../models/enums/rewardDescription";
import {Constants} from "./constants";
import {history} from './history';
import {router} from "./router";
import {SessionStorage} from "./sessionStorage";

export class Helpers {
  static wait = (ms: number = 1000) => new Promise((resolve) => setTimeout(resolve, ms));
  
  static isEnvProd(): boolean {
    const env: string = `${process.env.REACT_APP_ENV}`;
    return env === 'production';
  }
  
  static getQueryParam(query: string): string | null {
    const searchParams: URLSearchParams = new URLSearchParams(history.location.search);
    return searchParams.get(query);
  }
  
  static isFreshData(prevPropsState: State, propsState: State): boolean {
    if (prevPropsState.loading && !propsState.loading) {
      if (propsState.data) {
        return true;
      }
    }
    return false;
  }
  
  static getLocaleDate(date?: string, isTime: boolean = true): string {
    moment.locale('tr');
    return !!date ? moment(date).format(isTime ? Constants.dateTimeFormatUI : Constants.dateFormatUI) : '';
  }
  
  private static getJwt(token: string): JwtDto {
    return jwt_decode(token) as JwtDto;
  }
  
  static getMsisdnFromJwt(): string | undefined {
    const token = SessionStorage.get(SessionStorage.token);
    if (token) {
      return this.getJwt(token).sub;
    }
  }
  
  static isRouteMisc(path: string): boolean {
    return (
      path === router.FAQ ||
      path === router.CONTACT
    );
  }
  
  static isRoutePayByMeResult(path: string): boolean {
    return (
      path === router.PAY_BY_ME_SUCCESS ||
      path === router.PAY_BY_ME_FAILED
    );
  }
  
  static getOptionTypeFromIndex(index: number): OptionType {
    switch (index) {
      case (0):
        return OptionType.A;
      case (1):
        return OptionType.B;
      case (2):
        return OptionType.C;
      case (3):
        return OptionType.D;
      case (4):
        return OptionType.E;
      default:
        return OptionType.A;
    }
  }
  
  static getRewardDescriptionFromRewards(rewards?: RewardDto[]): RewardDescription {
    if (rewards && rewards.length > 0) {
      const reward = rewards[0];
      return reward.description;
    }
    return RewardDescription.none;
  }
  
  static getApiEventCoreData(me?: MeDto) {
    if (!me) {
      alert('Missing user data!');
      return {
        product: "dobosyok",
        userId: 0, // request validity check
        msisdn: "0",
      }
    }
    return {
      product: "dobosyok",
      userId: me.id,
      msisdn: me.msisdn,
    }
  }
}
